import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';
import { MatDialog } from '@angular/material/dialog';
import { TurnsAppointmentConfirmationDialogComponent } from '../turns-appointment-confirmation-dialog/turns-appointment-confirmation-dialog.component';
import * as moment from 'moment/moment';
import { tap } from 'rxjs/internal/operators/tap';

@Component({
  selector: 'app-turns-appointments-list-card',
  templateUrl: './turns-appointments-list-card.component.html',
  styleUrls: ['./turns-appointments-list-card.component.scss']
})
export class TurnsAppointmentsListCardComponent implements OnInit, OnDestroy {

  @Input() data;
  creationDateOrder;
  appointmentFormOrder;
  appointmentDeskOrder;
  userNameOrder;
  userSurnameOrder;
  userMailOrder;
  userDniOrder;
  userPassportOrder;
  userCardOrder;
  userLicensePlateOrder;
  userTelephoneOrder;
  appointmentDateOrder;
  appointmentTakenOrder;
  validateAppointmentSubscription: Subscription;

  constructor(private dialog: MatDialog) { }

  ngOnInit() {
    this.resetSortOrders();
  }


  public resetSortOrders() {
    this.creationDateOrder = 0;
    this.appointmentTakenOrder = 0;
    this.appointmentFormOrder = 0;
    this.appointmentDeskOrder = 0;
    this.userNameOrder = 0;
    this.userSurnameOrder = 0;
    this.userMailOrder = 0;
    this.userDniOrder = 0;
    this.userPassportOrder = 0;
    this.userCardOrder = 0;
    this.userLicensePlateOrder = 0;
    this.userTelephoneOrder = 0;
    this.appointmentDateOrder = 0;
  }

  public sortBy(attribute) {
    switch (attribute) {
      case 'creationDate':
        this.creationDateOrder = (this.creationDateOrder === 0) ? 1 : (this.creationDateOrder === 1) ? -1 : 1;
        this.data = this.data.sort(
          (a, b) => {
            a.CreationDate = a.CreationDate ? a.CreationDate : ' ';
            b.CreationDate = b.CreationDate ? b.CreationDate : ' ';
            return (a.CreationDate < b.CreationDate) ? -this.creationDateOrder : (a.CreationDate) ? this.creationDateOrder : 0;
          });
        break;
      case 'appointmentForm':
        this.appointmentFormOrder = (this.appointmentFormOrder === 0) ? 1 : (this.appointmentFormOrder === 1) ? -1 : 1;
        this.data = this.data.sort(
          (a, b) => {
            a.TurnFormName = a.TurnFormName ? a.TurnFormName : ' ';
            b.TurnFormName = b.TurnFormName ? b.TurnFormName : ' ';
            return (a.TurnFormName.toUpperCase() < b.TurnFormName.toUpperCase()) ? -this.appointmentFormOrder : (a.TurnFormName.toUpperCase() > b.TurnFormName.toUpperCase()) ? this.appointmentFormOrder : 0;
          });
        break;
      case 'appointmentDesk':
        this.appointmentDeskOrder = (this.appointmentDeskOrder === 0) ? 1 : (this.appointmentDeskOrder === 1) ? -1 : 1;
        this.data = this.data.sort(
          (a, b) => {
            a.TurnDeskName = a.TurnDeskName ? a.TurnDeskName : ' ';
            b.TurnDeskName = b.TurnDeskName ? b.TurnDeskName : ' ';
            return (a.TurnDeskName.toUpperCase() < b.TurnDeskName.toUpperCase()) ? -this.appointmentDeskOrder : (a.TurnDeskName.toUpperCase() > b.TurnDeskName.toUpperCase()) ? this.appointmentDeskOrder : 0;
          });
        break;
      case 'userName':
        this.userNameOrder = (this.userNameOrder === 0) ? 1 : (this.userNameOrder === 1) ? -1 : 1;
        this.data = this.data.sort(
          (a, b) => {
            a.UserName = a.UserName ? a.UserName : ' ';
            b.UserName = b.UserName ? b.UserName : ' ';
            return (a.UserName.toUpperCase() < b.UserName.toUpperCase()) ? -this.userNameOrder : (a.UserName.toUpperCase() > b.UserName.toUpperCase()) ? this.userNameOrder : 0;
          });
        break;
      case 'userSurname':
        this.userSurnameOrder = (this.userSurnameOrder === 0) ? 1 : (this.userSurnameOrder === 1) ? -1 : 1;
        this.data = this.data.sort(
          (a, b) => {
            a.UserSurname = a.UserSurname ? a.UserSurname : ' ';
            b.UserSurname = b.UserSurname ? b.UserSurname : ' ';
            return (a.UserSurname.toUpperCase() < b.UserSurname.toUpperCase()) ? -this.userSurnameOrder : (a.UserSurname.toUpperCase() > b.UserName.toUpperCase()) ? this.userSurnameOrder : 0;
          });
        break;
      case 'userMail':
        this.userMailOrder = (this.userMailOrder === 0) ? 1 : (this.userMailOrder === 1) ? -1 : 1;
        this.data = this.data.sort(
          (a, b) => {
            a.UserMail = a.UserMail ? a.UserMail : a.UserMail;
            b.UserMail = b.UserMail ? b.UserMail : b.UserMail;
            return (a.UserMail < b.UserMail) ? -this.userMailOrder : (a.UserMail > b.UserMail) ? this.userMailOrder : 0;
          });
        break;
      case 'userDni':
        this.userDniOrder = (this.userDniOrder === 0) ? 1 : (this.userDniOrder === 1) ? -1 : 1;
        this.data = this.data.sort(
          (a, b) => {
            a.UserDni = a.UserDni ? a.UserDni : a.UserDni;
            b.UserDni = b.UserDni ? b.UserDni : b.UserDni;
            return (a.UserDni < b.UserDni) ? -this.userDniOrder : (a.UserDni > b.UserDni) ? this.userDniOrder : 0;
          });
        break;
      case 'userPassport':
        this.userPassportOrder = (this.userPassportOrder === 0) ? 1 : (this.userPassportOrder === 1) ? -1 : 1;
        this.data = this.data.sort(
          (a, b) => {
            a.UserPassport = a.UserPassport ? a.UserPassport : a.UserPassport;
            b.UserPassport = b.UserPassport ? b.UserPassport : b.UserPassport;
            return (a.UserPassport < b.UserPassport) ? -this.userPassportOrder : (a.UserPassport > b.UserPassport) ? this.userPassportOrder : 0;
          });
        break;
      case 'userCard':
        this.userCardOrder = (this.userCardOrder === 0) ? 1 : (this.userCardOrder === 1) ? -1 : 1;
        this.data = this.data.sort(
          (a, b) => {
            a.UserCard = a.UserCard ? a.UserCard : a.UserCard;
            b.UserCard = b.UserCard ? b.UserCard : b.UserCard;
            return (a.UserCard < b.UserCard) ? -this.userCardOrder : (a.UserCard > b.UserCard) ? this.userCardOrder : 0;
          });
        break;
      case 'licensePlate':
        this.userLicensePlateOrder = (this.userLicensePlateOrder === 0) ? 1 : (this.userLicensePlateOrder === 1) ? -1 : 1;
        this.data = this.data.sort(
          (a, b) => {
            a.UserLicensePlate = a.UserLicensePlate ? a.UserLicensePlate : a.UserLicensePlate;
            b.UserLicensePlate = b.UserLicensePlate ? b.UserLicensePlate : b.UserLicensePlate;
            return (a.UserLicensePlate < b.UserLicensePlate) ? -this.userLicensePlateOrder : (a.UserLicensePlate > b.UserLicensePlate) ? this.userLicensePlateOrder : 0;
          });
        break;
      case 'userTelephone':
        this.userTelephoneOrder = (this.userTelephoneOrder === 0) ? 1 : (this.userTelephoneOrder === 1) ? -1 : 1;
        this.data = this.data.sort(
          (a, b) => {
            a.UserTelephone = a.UserTelephone ? a.UserTelephone : a.UserTelephone;
            b.UserTelephone = b.UserTelephone ? b.UserTelephone : b.UserTelephone;
            return (a.UserTelephone < b.UserTelephone) ? -this.userTelephoneOrder : (a.UserTelephone > b.UserTelephone) ? this.userTelephoneOrder : 0;
          });
        break;

      case 'appointmentDate':
        this.appointmentDateOrder = (this.appointmentDateOrder === 0) ? 1 : (this.appointmentDateOrder === 1) ? -1 : 1;
        this.data = this.data.sort(
          (a, b) => {
            a.AppointmentDate = a.AppointmentDate ? a.AppointmentDate : ' ';
            b.AppointmentDate = b.AppointmentDate ? b.AppointmentDate : ' ';
            return (a.AppointmentDate < b.AppointmentDate) ? -this.appointmentDateOrder : (a.AppointmentDate) ? this.appointmentDateOrder : 0;
          });
        break;
    }
  }

  public isTurn(appointment) {
    if (appointment.AppointmentChecked) {
      return true;
    }
    return false;
  }

  public turnCanBeGot(appointment) {
    if ((moment().valueOf() >= (appointment.AppointmentDate - appointment.AllowBeforeMilliseconds)) && (moment().valueOf() <= (appointment.AppointmentDate + appointment.AllowAfterMilliseconds))) {
      return false;
    }
    return true;
  }

  public view(appointment) {
    const dialogRef = this.dialog.open(TurnsAppointmentConfirmationDialogComponent, { data: appointment });
    dialogRef.afterClosed().pipe(
      tap(res => this.setTemporalChecked(appointment))
    ).subscribe();
  }

  private setTemporalChecked(appointment) {
    this.data.forEach(d => {
      if (appointment.InternalId === d.InternalId) {
        d.AppointmentChecked = true;
      }
    });
  }

  ngOnDestroy() {
    if (this.validateAppointmentSubscription) { this.validateAppointmentSubscription.unsubscribe(); }
  }
}
